import styled from '@emotion/styled'

const ONE_PIXEL = 0.0625 // 1/16th of 1em : 1em = 16px

function hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16)

    if (alpha) {
        return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')'
    } else {
        return 'rgb(' + r + ', ' + g + ', ' + b + ')'
    }
}

const getBorderWidth = borderWidth => (borderWidth ? `${borderWidth}px` : '1px')

export const ComponentWrapper = styled.div`
    position: relative;

    background-color: ${props =>
        `${
            props.backgroundColor
                ? hexToRGB(props.backgroundColor, props.backgroundColorOpacity)
                : ''
        }`};
    background-image: ${props => (props.backgroundImage ? `url(${props.backgroundImage})` : null)};
    background-position: ${props => props.backgroundPosition};
    background-size: ${props => props.backgroundSize};
    background-repeat: ${props => props.backgroundRepeat || 'no-repeat'};

    padding-top: ${props =>
        (props.paddingMobile ? (props.padding?.top || 0) / 2 : props.padding?.top || 0) *
        ONE_PIXEL}em;
    padding-right: ${props =>
        (props.paddingMobile ? (props.padding?.right || 0) / 2 : props.padding?.right || 0) *
        ONE_PIXEL}em;
    padding-bottom: ${props =>
        (props.paddingMobile ? (props.padding?.bottom || 0) / 2 : props.padding?.bottom || 0) *
        ONE_PIXEL}em;
    padding-left: ${props =>
        (props.paddingMobile ? (props.padding?.left || 0) / 2 : props.padding?.left || 0) *
        ONE_PIXEL}em;

    margin-top: ${props => (props.margin?.top > 0 ? props.margin.top : 0) * ONE_PIXEL}em;
    margin-bottom: ${props => (props.margin?.bottom || 0) * ONE_PIXEL}em;

    /* prevent margin indenting single column items */
    margin-right: 0em;
    margin-left: 0em;

    @media all and (min-width: 768px) {
        margin-top: ${props => (props.margin?.top || 0) * ONE_PIXEL}em;

        margin-right: ${props => (props.margin?.right || 0) * ONE_PIXEL}em;
        margin-left: ${props => (props.margin?.left || 0) * ONE_PIXEL}em;

        padding-top: ${props => (props.padding?.top || 0) * ONE_PIXEL}em;
        padding-right: ${props => (props.padding?.right || 0) * ONE_PIXEL}em;
        padding-bottom: ${props => (props.padding?.bottom || 0) * ONE_PIXEL}em;
        padding-left: ${props => (props.padding?.left || 0) * ONE_PIXEL}em;
    }

    border-top-width: ${props =>
        ['top', 'both'].includes(props.borderY) ? getBorderWidth(props.borderWidth) : 0};
    border-top-style: ${props => props.borderStyle || 'solid'};
    border-top-color: ${props => props.borderColor || 'rgba(0,0,0,0.1)'};

    border-bottom-width: ${props =>
        ['bottom', 'both'].includes(props.borderY) ? getBorderWidth(props.borderWidth) : 0};
    border-bottom-style: ${props => props.borderStyle || 'solid'};
    border-bottom-color: ${props => props.borderColor || 'rgba(0,0,0,0.1)'};

    border-left-width: ${props =>
        ['left', 'both'].includes(props.borderX) ? getBorderWidth(props.borderWidth) : 0};
    border-left-style: ${props => props.borderStyle || 'solid'};
    border-left-color: ${props => props.borderColor || 'rgba(0,0,0,0.1)'};

    border-right-width: ${props =>
        ['right', 'both'].includes(props.borderX) ? getBorderWidth(props.borderWidth) : 0};
    border-right-style: ${props => props.borderStyle || 'solid'};
    border-right-color: ${props => props.borderColor || 'rgba(0,0,0,0.1)'};

    overflow: ${props => (props.backgroundMode === 3 ? 'hidden' : 'visible')};

    box-shadow: ${props =>
        props.boxShadow ? props?.theme?.boxShadow || '0 0 10px 1px rgba(0, 0, 0, 0.25)' : 'none'};

    &.zoom {
        transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
        box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.25);
        transform: translateZ(0);
        backface-visibility: none;

        &:hover {
            transform: scale(1.05);
            box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.25);
        }
    }
`

export const ComponentBorder = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    border-width: 0px;
    border-style: none;
    border-color: ${props =>
        props.highlight ? (props.isLayoutPlugin ? 'red' : 'blue') : '#c3c3c3'};
    pointer-events: none;
`

export const ComponentVideo = styled.video`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 0;

    + div {
        position: inherit;
    }
`
